import React, { useMemo } from 'react';
import { CommandBarGenericUI } from '@cube3/ui/src/library/CommandBar/CommandBarUI';
import { useButtonConfig } from '../../../../layout/CommandBar/useButtonConfig';
import { MetadataEditButtonFactory } from '../../../../layout/CommandBar/factories/editButton/MetadataEditButtonFactory';
import { useEditVisitingMetadataAction } from '@cube3/state/src/redux/components/Hooks/useEditAction';

const MetadataOverviewCommandBar: React.FunctionComponent = (props) => {
  const editAction = useEditVisitingMetadataAction();

  // Factories
  const primaryBtnFactories = useMemo(
    () => [MetadataEditButtonFactory(editAction, 'Edit metadata')],
    [editAction]
  );

  // Button configs
  const primaryBtnsConfig = useButtonConfig(primaryBtnFactories);

  return <CommandBarGenericUI primaryButtonsConfig={primaryBtnsConfig} />;
};

export default MetadataOverviewCommandBar;
